import { type EWithdrawalStatus } from '@mahawi/eshop-common/src/types';
import { Tag, Typography } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import { EDateFormat } from '../../fragments/date-format';
import { getTagByRelativeDate } from '../../fragments/get-tag-by-relative-date';
import { WITHDRAWAL_OPEN_STATUSES } from './labels';

function RefundDue({
  status,
  refundDueAt,
}: {
  status: EWithdrawalStatus;
  refundDueAt: string;
}): React.ReactElement {
  const formatted: string = dayjs(refundDueAt).format(EDateFormat.DATE);

  if (!WITHDRAWAL_OPEN_STATUSES.includes(status)) {
    return <Typography.Text type="secondary">{formatted}</Typography.Text>;
  }

  if (dayjs(refundDueAt).isBefore(dayjs())) {
    return <Tag color="red">{`Overdue since ${formatted}`}</Tag>;
  }

  return (
    <span title={formatted}>
      {getTagByRelativeDate({ date: new Date(refundDueAt) })}
    </span>
  );
}

export default RefundDue;
